module.exports = __webpack_public_path__ + "img/pricing_1.21792930.png";